module.exports = __webpack_public_path__ + "img/map.e87ec72e.svg";